import React, { useEffect } from "react";
import gql from "graphql-tag";
import { useMutation } from "@apollo/client";
import Loader from "../../components/Loader";
import { useNavigate, useLocation } from "react-router-dom"; // Zaktualizowano importy
import { usePopup } from "../../context/PopupContext";
import { useUserContext } from "../../context/UserContext";

const UNSUBSCRIBE_ALL_MUTATION = gql`
    mutation productAlertsUnsubscribeAll {
        productAlertsUnsubscribeAll {
            status
            message
        }
    }
`;

const ProductAlertUnsubscribeAll = () => {
    const { showAddToCartPopupMessage } = usePopup();
    const navigate = useNavigate(); // Zamiana useHistory na useNavigate
    const location = useLocation(); // Dodano useLocation dla pathname
    const { user } = useUserContext();
    const [unsubscribeAll, { loading }] = useMutation(UNSUBSCRIBE_ALL_MUTATION, {
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        // Przekierowanie do logowania, jeśli użytkownik nie jest zalogowany
        if (!user) {
            navigate(`/customer/login?referrer=${location.pathname}`);
            return;
        }

        // Wykonanie mutacji
        unsubscribeAll()
            .then((result) => {
                const data = result.data.productAlertsUnsubscribeAll;
                if (data) {
                    showAddToCartPopupMessage(
                        data.message,
                        data.status === true ? "success" : "error",
                        4000
                    );
                }
                navigate("/");
            })
            .catch((error) => {
                console.error("Unsubscribe all error:", error);
                showAddToCartPopupMessage(
                    "Failed to unsubscribe from all product alerts",
                    "error",
                    4000
                );
                navigate("/");
            });
    }, [user, navigate, location.pathname, unsubscribeAll, showAddToCartPopupMessage]); // Dodane zależności

    return <Loader />;
};

export default ProductAlertUnsubscribeAll;